/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Font_Size_LabelInputs */



/**
* | output |
* | --- |
* | "Font Size (px)" |
*
* @param {Edit_Event_Group_Font_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_font_size_label = /** @type {((inputs?: Edit_Event_Group_Font_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Font_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Taille de police (px)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftgröße (px)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dimensione carattere (px)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Размер шрифта (пиксели)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tamaño de fuente (px)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字体大小（像素）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォントサイズ（ピクセル）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉन्ट आकार (px)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tamanho da fonte (px)")
	return /** @type {LocalizedString} */ ("Font Size (px)")
});